import { TableCell, Typography } from "@mui/material";
import React from "react";

const reportsTraduction = [
  { name: "Generado", value: "GENERATED" },
  { name: "Generando", value: "GENERATING" },
  { name: "Pendiente", value: "PENDING" },
]


const ReportsTableRows = ({ report }) => {
  const reportStatus = reportsTraduction.find(status => status.value === report.status)?.name || 'Estado desconocido';

  return (
    <>
      <TableCell align='left'>
        <Typography variant='body'>{report.id}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>{report.name}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>{reportStatus}</Typography>
      </TableCell>
    </>
  );
};

export default ReportsTableRows;
